export const ResourceTypes = {
  ExportedNomination: 'ExportedNomination',
  ExportedAwardNominations: 'ExportedAwardNominations',
  ExportedProgramCountryNominations: 'ExportedProgramCountryNominations',
  SupportingDocument: 'SupportingDocument',
  ExportedAwardNominationSummaries: 'ExportedAwardNominationSummaries',
  ExportedProgramCountryAwardNominationSummaries: 'ExportedProgramCountryAwardNominationSummaries',
  ExecutiveSummary: 'ExecutiveSummary',
  AwardExecutiveSummary: 'AwardExecutiveSummary',
  UploadedMedia: 'UploadedMedia',
} as const;

export const EmailResourceTypes = {
  EmailBannerImage: 'EmailBannerImage',
  EmailAttachment: 'EmailAttachment',
} as const;

export type EmailResourceType = typeof EmailResourceTypes[keyof typeof EmailResourceTypes];

export interface ResourceTicketRequest {
    data: ResourceTicketData;
    resourceType: string;
}

export interface ResourceTicketData
{
    routeData?: RouteData;
    queryString?: QueryString;
}

export interface RouteData {
  awardId?: number;
  nominationId?: number;
  emailTemplateId?: number;
  emailTemplateAttachmentId?: number;
  emailTemplateBannerImageId?: number;
  programId?: number;
  countryId?: number;
  supportingDocumentId?: number;
  uploadedMediaId?: number;
}

export interface QueryString {
  isDisplayedAsInline?: string;
  selectedFields?: string;
  tag?: string;
  searchText?: string;
  nominationIds?: string;
  awardIds?: string;
  exportType?: string;
}
